export function deriveTextEmbroideryFontFamilyFromStyle(fontStyle) {
    switch (fontStyle) {
        case 'Script':
            return 'VarsityScriptJF';
        case 'Block':
            return 'Helvetica';
        default:
            return fontStyle;
    }
}
//# sourceMappingURL=utils.js.map